import { NumericValueType, numeric, prop, required } from "@rxweb/reactive-form-validators";
import { ProfileModel } from "../profile-management/profile-model";
import { LeaveEntitlementModel } from "../leave-entitlement-managament/leave-entitlement-management.model";

export class LeaveRequestModel {
    @prop()
    leaveRequestId: number;
    @prop()
    profileId: string;
    profile: ProfileModel | null;
    @prop()
    @required()
    leaveDateFrom: Date | string | null;
    @prop()
    @required()
    leaveDateTo: Date | string | null;
    @prop()
    @required()
    leaveType: number;
    leaveEntitlement: LeaveEntitlementModel | null;
    @prop()
    session: string;
    @prop()
    @numeric({ acceptValue: NumericValueType.PositiveNumber, allowDecimal: true, message: 'Only numberic is allowed' })
    numberOfHour: number = 0;
    @prop()
    statusID: number;
    @prop()
    note: string;
    @prop()
    @required()
    title: string;
    @prop()
    leaveBudgetId: number;
    timeZone: number;

    ownerId: string;
    extendData: string;
    dateCreated: Date | string | null;
}

export class BonusBalanceModel {
    usableHours: number;
    usedHours: number;
    pendingHours: number;
    freeHours: number;
    pendingRequestIds: number[];
}

export class LeaveEntitlementGrantModel {
    grantId: number;
    leaveEntitlementId: number;
    leaveEntitlement: LeaveEntitlementModel | null;
    profileId: string;
    profile: ProfileModel | null;
    hours: number;
    reason: string;
    note: string;
    // 'byHours' or 'byDate'
    option: string;
    leaveRequestId: number | null;
    // Only a byDate grant has one: it holds the dates booked together with the grant.
    leaveRequest: LeaveRequestModel | null;
    // 'Active' or 'Revoked'
    status: string;
    grantedBy: string;
    revokedBy: string;
    revokedAt: Date | string | null;
    revokeReason: string;
    dateCreated: Date | string | null;
    dateModified: Date | string | null;
}

export class LeaveBonusModel {
    @prop()
    leaveRequestId: number;
    @prop()
    lstProfileId: string[];
    @prop()
    leaveDateFrom: Date | string | null;
    @prop()
    leaveDateTo: Date | string | null;
    @prop()
    session: string;
    @prop()
    @numeric({ acceptValue: NumericValueType.PositiveNumber, allowDecimal: true, message: 'Only numberic is allowed' })
    numberOfHour: number = 0;
    @prop()
    note: string;
    @prop()
    @required()
    title: string;
    timeZone: number;

    ownerId: string;
    extendData: string;
}